enum Category {
  BETFAIR = 1,
  FANCYBET = 2,
  SPORTRADAR_SPORTSBOOK = 4,
  BOOK_MAKER = 5,
  TS_BINARY = 6,
  DM_FANCYBET = 6,
  DM_BOOK_MAKER = 7,
  GENIUSSPORTS_SPORTSBOOK = 8
}

enum FrontSettingCategory {
  DM_FANCYBET_PLUS = 61
}

const categoryTypeConst = Object.freeze({
  BETFAIR: Category.BETFAIR,
  FANCYBET: Category.FANCYBET,
  SPORTRADAR_SPORTSBOOK: Category.SPORTRADAR_SPORTSBOOK,
  GENIUSSPORTS_SPORTSBOOK: Category.GENIUSSPORTS_SPORTSBOOK,
  BOOK_MAKER: Category.BOOK_MAKER,
  DM_FANCYBET: Category.DM_FANCYBET,
  DM_BOOK_MAKER: Category.DM_BOOK_MAKER,
  DM_FANCYBET_PLUS: FrontSettingCategory.DM_FANCYBET_PLUS
})

export default categoryTypeConst
export { Category, categoryTypeConst }
